export const config = {
    type: 'DANMAKU',
    title: '顶部弹幕',
    defaultProps: {
        danmakus: [
            {
                text: '恭喜小马已经加入群聊',
                avatar: '',
                textColor: '#fff',
                speed: 8,
                fontSize: 18,
                backgroundColor: 'rgba(0, 0, 0, 0.5)'
            },
            {
                text: '期待与您的交流',
                avatar: '',
                textColor: '#fff',
                speed: 10,
                fontSize: 18,
                backgroundColor: 'rgba(0, 0, 0, 0.5)'
            }
        ]
    },
    preview: {
        style: {
            padding: '8px',
            position: 'relative',
            height: '60px',
            overflow: 'hidden'
        },
        items: [
            {
                style: {
                    position: 'absolute',
                    top: '8px',
                    left: '20%',
                    width: '120px',
                    height: '12px',
                    background: 'var(--semi-color-fill-1)'
                }
            },
            {
                style: {
                    position: 'absolute',
                    top: '28px',
                    left: '40%',
                    width: '100px',
                    height: '12px',
                    background: 'var(--semi-color-fill-2)'
                }
            },
            {
                style: {
                    position: 'absolute',
                    top: '48px',
                    left: '10%',
                    width: '140px',
                    height: '12px',
                    background: 'var(--semi-color-fill-1)'
                }
            }
        ]
    }
};